// Bepaalt activatiestatus uit signalen.
// Heuristiek (geen expliciete onboarding-completion timestamp beschikbaar):
//   - <14wd oud + geen signalen → not-activated (te jong, niets gebeurt)
//   - <60wd oud + geen eerste cyclus → in-onboarding (mag nog even)
//   - >60wd oud + geen eerste cyclus → not-activated (heeft 't nooit gedaan)
//   - eerste cyclus voltooid + geen follow-up gepland → in-transition
//   - eerste cyclus + follow-up gepland → activated
// Drempels in thresholds.js — wijzig daar om te herijken.

import { ONBOARDING_GRACE_BUSINESS_DAYS, ONBOARDING_MAX_BUSINESS_DAYS } from './thresholds';

const computeActivationStatus = (entity, signals) => {
    const noSignals =
        signals.lastLoginBusinessDaysAgo === null &&
        signals.eventsLast8w === 0 &&
        signals.researchesLast12mo === 0 &&
        signals.tasksPlannedNext30wd === 0;

    if (signals.daysSinceCreated < ONBOARDING_GRACE_BUSINESS_DAYS && noSignals) {
        return 'not-activated';
    }

    const hasFirstCycle = signals.eventsLast8w > 0 || signals.researchesLast12mo > 0;
    if (!hasFirstCycle) {
        // Onboarding-window verstreken zonder eerste cyclus → activatie nooit geland
        if (signals.daysSinceCreated > ONBOARDING_MAX_BUSINESS_DAYS) return 'not-activated';
        return 'in-onboarding';
    }

    const hasNextPlanned = signals.tasksPlannedNext30wd > 0;
    if (!hasNextPlanned) return 'in-transition';

    return 'activated';
};

export default computeActivationStatus;
